import { AppSharedModule } from '../app-shared.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '../components/components.module';
import { MensagemControleListaComponent } from './mensagem-controle-lista/mensagem-controle-lista.component';
import { MensagemControleService } from './mensagem-controle.service';
import { MensagemControleRoutingModule } from './mensagem-controle.routing';
import { MensagemControleExecutarPendentesComponent } from './mensagem-controle-executar-pendentes/mensagem-controle-executar-pendentes.component';

@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule,
  ],
  declarations: [
    MensagemControleListaComponent,
    MensagemControleExecutarPendentesComponent
  ],
  exports: [
    MensagemControleRoutingModule
  ],
  providers: [
    MensagemControleService
  ]
})
export class MensagemControleModule { }
